<template>
  <div class="container home-mobile ">
    <header class="top-header" id="head-box">
      <div class="top" >
        <div class="max-box">
          <img
            src="../assets/images/Home/top-logo.png"
            class="logo-img"
            alt=""
          />
          <span class="more-icon">
<van-popover
  theme="dark"
  placement="bottom-end"
  v-model="showPopover"
  trigger="click"
  :actions="actions"
  @select="onSelect"
>
  <template #reference>
    <span class="btn-self" type="primary"></span>
  </template>
</van-popover>
          </span>
        </div>
      </div>
      <div class="banner full-box wow fadeInUp "  ref="pronbit">
        <div class="common-box word-container">
          <span class="w1">您值得拥有</span>
          <span class="w2">一个充满科技和艺术的数据服务平台</span>
          <span class="w3">就在商车数科 sx-scsj.com</span>
        </div>
      </div>
    </header>
    <div class="parent-box  wow swing" data-wow-delay="0.3s" id="company-box">
      <div class="company-box common-box ">
        <header class="header">
          介绍<span class="orange-color">公司</span>做什么
        </header>
        <section>
          <div></div>
          <div class="text-intro">
            <div>
              西安商车数字科技有限公司是一支最具活力和最具竞争力的商务管理软件科研开发商之一,是中国软件产业的杰出代表。自成立以来，西安商车数字科技有限公司时刻关注着物流行业管理软件市场的需求，以中小企业管理的规范化、科学化、现代化为已任，把适合中国国情的物流行业管理软件开发当做自己的使命，研发出一系列管理软件，网络货运平台、无人值守称重系统、进销存ERP系统、工程机械租赁平台，满足了不同企业的需求。
            </div>
            <div>
              经过多年努力，西安商车数字科技有限公司的客户拥有量和市场占有率迅速扩大，其中网络货运平台软件、无人值守称重系统已经成为该行业管理软件的知名品牌。商车数字的进销存ERP系统管理软件赢得了全国各地用户的好评。经过不断的积累与发展，公司的科研队伍不断壮大。公司拥有一支由计算机软件专家和商务管理专家共同组成的一流的科研开发队伍。
            </div>
          </div>
        </section>
      </div>
    </div>

    <div class="parent-box product-box wow bounceInLeft "  id="product-box">
      <header class="header ">
        再看看<span class="orange-color">产品</span>有哪些
      </header>
      <ul >
        <li v-for="(item, idx) in pd" :key="idx">
          <Card :item="item"></Card>
        </li>
      </ul>
    </div>
    <div class="parent-box example-box wow bounceInRight"   id="example-box">
      <header class="header">
        来看一些<span class="orange-color">案例</span>吧
      </header>
      <div class="common-box example-container">
        <div></div>
        <div class="wow bounceInRight">
          <span>慧称重</span>
          <section class="wow bounceInUp">
            智能称重系统可有效减少人员管理成本，提高工作效率；避免称重作弊为企业带来损失；与ERP云平台无缝对接、实现数据共享，方便快捷；通过软件自动控制，严格权限管理，确保系统安全；用户体验快捷、方便、效率高。
          </section>
        </div>
        <div></div>
        <div class="wow bounceInRight">
          <span>网络货运平台</span>
          <section class="wow bounceInUp">
            全供应链大数据平台，以大数据物流为核心，集物流、贸易、金融一体的产业数据中心支持，具备相应的数据交互及处理能力，对实际承运人的车辆运营情况进行全程透明化安全监管，为货主和实际承运人提供信息及管理服务，对交易、运输、结算等各环节进行全程动态管理，提高企业运作效率及服务质量。
          </section>
        </div>
        <div></div>
        <div class="wow bounceInLeft">
          <span>慧运输</span>
          <section class="wow bounceInUp"> 
            煤矿运销平台融合了运销管理理念，降低操作人员工作强度，对车辆进出进行规范严格的管理，发运煤场远程放仓操作、无人值守称重系统、全方位视频监控、IC卡应用等管控技术，有效规范运销流程，对企业运输煤炭可视化现场管控，无人值守防作弊管控，提高作业效率优化作业模式起到了重要作用。
          </section>
        </div>
      </div>
    </div>
    <div class="rz-box parent-box wow bounceInLeft" >
      <header class="header">
        公司的众多<span class="orange-color">软著</span>
      </header>
      <div class="rz-container common-box">
        <div class="wow fadeInUp"></div>
        <div class="wow fadeInUp"></div>
        <div class="wow fadeInUp"></div>
        <div class="wow fadeInUp"></div>
        <div class="wow fadeInUp"></div>
      </div>
    </div>
    <div class="zz-box parent-box wow bounceInLeft" id="zz-box">
      <header class="header">
        我们的<span class="orange-color">资质</span>还有很多
      </header>
      <div class="zz-container common-box">
        <div  class="wow fadeInUp"></div>
        <div  class="wow fadeInUp"></div>
        <div  class="wow fadeInUp"></div>
        <div  class="wow fadeInUp"></div>
        <div  class="wow fadeInUp"></div>
        <div  class="wow fadeInUp"></div>
        <div  class="wow fadeInUp"></div>
        <div  class="wow fadeInUp"></div>
        <div  class="wow fadeInUp"></div>
      </div>
    </div>

    <footer>
      <div class="footer-box">
        <div class="common-box flex-row">
          <div>
            <span class="title">联系我们</span><span>4008722166</span
            ><span>8538206@qq.com</span>
          </div>
          <div>
            <span class="title">企业地址</span
            ><span>西安市雁塔区金辉环球广场E栋10820室</span>
          </div>
          <div>
            <span class="title">扫码咨询</span
            ><img src="../assets/images/Home/scan1.jpeg" alt="" />
          </div>
        </div>
      </div>
      <div class="footer-container">
        Copyright © 版权所有 陕ICP备19005317号-1
      </div>
    </footer>
  </div>
</template>

<script>
import Card from "@src/componentsNew/common/CardMobile";
import { Popover , Toast} from 'vant'
export default {
  data() {
    return {
      actions: [{ text: '公司简章',key:'gsjz' }, { text: '产品介绍',key:'cpjz' }, { text: '经典案例',key:'jdal' },{ text: '企业资质' ,key:'qyzz'}],
      showPopover:false,
      active: 4,
      pd: [
        {
          title: "网络货运平台",
          content:
            "为企业快人一步打造一站式网络货运平台，支持云端部署或本地化部署，可根据需求定制个性化服务并支持多元化业务。网络货运专家解读最新政策，全程协助资质申报和信息系统安全等级保护备案证明；协助企业品牌推广，提升快速获客能力。系统可根据业务需求撮合代征司机的运费专票，解决企业财务管理进项难题，将企业税负成本控制在3%-5%之间。同时将在运营策略上进行指导，有效降低企业运营成本，配有专职项目实施人员指导服务，进而保证实现快速盈利。",
          bg: "1-pd.png",
        },
        {
          title: "慧称重",
          content:
            "慧称重系统即无人值守称重管理系统，是为企业提供一个全面的信息管理平台，实现原料采购、产品销售、计划下发、自助派车、自助取卡排队、自助叫号（包含自动、手动）、门禁自助验证、无人值守计量、装卸货验证、财务结算、报表统计分析等运销业务的信息化和自动化，企业的日常业务在信息系统的协助下变得高效、快捷。一方面可以实现对厂区车辆进行规范化管理，提高装卸车发运效率。另一方面可以利用信息化手段实现业务流程的闭环管理、防作弊管理，进而实现企业经营风险管控。让集团在集成化的办公平台下实现数据、单据、报表、等资源的共享。",
          bg: "2-pd.png",
        },
        {
          title: "慧运销",
          content:
            "慧运销系统即企业ERP系统，在管理企业运营情况的同时还降低了企业的经营成本，提高企业竞争能力。其次对账单、汇总、明细及价格也能轻松便捷的管理，提高企业审核时间。保证企业信息“资金流”与“物流”的同步一致，有效改善资金信息滞后与物料信息的数据同步情况，为财务人员快捷核算成本。进销存ERP系统的无缝结合帮助企业大大提高了经营效率。",
          bg: "3-pd.png",
        },
        {
          title: "慧租赁",
          content:
            "工程机械租赁平台是车辆与工程机械租赁一站式解决服务平台，以互联网和租赁为抓手，深度链接产业链上下游企业，为客户提供全方位信息化租赁解决方案，为企业实现轻资产运营提供强力的后方保障，在全产业实现实现无纸化、无人化、数字化、可视化、智能化全面转变。利用新科技、新体系把设备资源重新找到最合理的配置，让整个经济体得到优化，从而消灭信息不对称，加速该经济体的发展，为工程建筑行业提供方位租赁定制化服务，和企业一同发展实现共赢。",
          bg: "4-pd.png",
        },
        {
          title: "慧商城",
          content:
            "商城平台与众多线下购物平台一样，除了为消费者提供优质产品及满意服务外，还在为商家提供更好的销售空间及销售机会。想要更好的发挥平台的作用为企业带来更好的效益。商家通过后台管理端可以了解到每天的订单数据详情，销售的产品情况，产品的类型，销售额，用户的商品评价这些信息可以通过后台的数据统一的了解管理，这样可以让经营者对于商家的经营情况有着更加多的了解。普通用户在购买了商品之后，商家可根据订单数据对于商品的发货处理，如未发货，已发货数据，物流数据查询，订单数据查询，这些订单数据详情的处理，满足到相应的订单数据的管理。",
          bg: "5-pd.png",
        },
        {
          title: "慧用工",
          content:
            "慧用工平台是连接用工公司和灵活就业人群的平台，企业把任务发布给平台，平台再转包给个人，一般平台会具有委托代征资质，为个人办理临时税务登记。随着互联网的发展越来越快，很多新型的行业越来越多。直播带货、网红经济，知识付费经济，网约车O2O等这是当下的互联网风口。企业在给兼职人员发放报酬时后却无法取得发票，灵活用工是可以代发薪资同时按核定征收缴纳个税，给企业开具发票，解决企业的钱出去后没有发票的问题。",
          bg: "6-pd.png",
        },
      ],
    };
  },

  created() {},
  destroyed() {},
  mounted() {

   // window.addEventListener("scroll", this.handleScrollx, true);
return;
    var scrollDiv = $(".home-mobile");
	var target = $(".");
	var scrollDivHeight = $(".home-mobile").height();
	
	var targetTop = target.offset().top;
	var scrollDivTop = scrollDiv.offset().top
	
	var toScroll = targetTop - scrollDivTop - scrollDivHeight; // scroll to see element
	var addToClass = target.attr('data-animation');
	var visibleClass = "visible";
	console.log('scrollDivHeight: ' + scrollDivHeight);
	console.log('targetTop: ' + targetTop);
	console.log('toScroll: ' + toScroll);
	console.log('addToClass: ' + addToClass);
	
	scrollDiv.scroll(function(){
		var scrolled = $(this).scrollTop();
		console.log('scrolled : '+scrolled);
		if(scrolled > toScroll){
			target.addClass(visibleClass).addClass(addToClass);
			console.log('"'+addToClass+'" has been added!');
		}else{
			target.removeClass(visibleClass).removeClass(addToClass);
		}
	});
  },
  methods: {
     onSelect(action) {
          switch (action.key) {
        case 'qyzz':
          document.getElementById("zz-box").scrollIntoView({ block: 'start', behavior: 'smooth' })
          break;
        case 'jdal':
          document.getElementById("example-box").scrollIntoView({ block: 'start', behavior: 'smooth' })
          break;
        case 'cpjz':
          document.getElementById("product-box").scrollIntoView({ block: 'start', behavior: 'smooth' })
          break;
        case 'gsjz':
          document.getElementById("head-box").scrollIntoView({ block: 'center', behavior: 'smooth' })
          break;
      }
    },
    handleScrollx() {
      console.log(this.$refs.pronbit.getBoundingClientRect().top )
      if(this.$refs.pronbit.getBoundingClientRect().top > -200){
        this.active = 4
      }
        if(this.$refs.pronbit.getBoundingClientRect().top > -2329 && this.$refs.pronbit.getBoundingClientRect().top < -357){
        this.active = 3
      }

   if(this.$refs.pronbit.getBoundingClientRect().top > -2800 && this.$refs.pronbit.getBoundingClientRect().top < -2100){
        this.active = 2
      }
 if(this.$refs.pronbit.getBoundingClientRect().top < -2800 ){
        this.active = 1
      }
    //   let r = Math.abs(this.$refs.pronbit.getBoundingClientRect().top)/1000
    // document.querySelector('.top').style.backgroundColor =`rgba(${r*50},${r*50},${r*20},${Math.abs(this.$refs.pronbit.getBoundingClientRect().top)/1000} `

    //   console.log(
    //     "距离顶部高度",
    //     this.$refs.pronbit.getBoundingClientRect().top
    //   );
    },
    move(idx) {
      this.active = idx;
      console.log(idx)
      //actions: [{ text: '公司简章',key:'gsjz' }, { text: '产品介绍',key:'cpjz' }, { text: '经典案例',key:'jdal' },{ text: '企业资质' ,key:'qyzz'}],

      switch (idx) {
        case 'qyzz':
          document.getElementById("zz-box").scrollIntoView({ block: 'center', behavior: 'smooth' })
          break;
        case 'jdal':
          document.getElementById("example-box").scrollIntoView({ block: 'center', behavior: 'smooth' })
          break;
        case 'cpjz':
          document.getElementById("product-box").scrollIntoView({ block: 'start', behavior: 'smooth' })
          break;
        case 'gsjz':
          document.getElementById("head-box").scrollIntoView({ block: 'center', behavior: 'smooth' })
          break;
      }
    },
  },
  components: {
    Card,
  },
};
</script>

<style lang="scss" scoped>
$orange-color: #fa6400;
.right-box{
  display: flex;
}
section{
   text-align: left;
    text-indent: 2em;
}

@mixin bg-common {
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-position: center;
}
.btn-self{
      width: 30px;
    height: 30px;
    display: inline-block;
}
.more-icon{
  @include bg-common;
  background-image: url('../assets/images/Home/more.png');
  display: inline-block;
  width:30px;
  height: 30px;
  position: absolute;
    right: 11px;;
}
#head-box{
  .max-box{
        display: flex;
    flex-direction: row;
    align-items: center;
  }
}
.home-mobile {
  display: flex;
  flex-direction: column;
  background-color: white;
  >div,>footer{
    display: block;
  }
  .top-header{
    margin-top:56px;
  }
  .active1 {
    transform: translateX(0px);
  }
  .active2 {
    transform: translateX(-90px);
  }
  .active3 {
    transform: translateX(-180px);
  }
  .active4 {
    transform: translateX(-270px);
  }
  .parent-box {
    background-color: #f6f6f6;
  }
  section {
    display: flex;
    text-align: left;
    flex-direction: column;
    > div:nth-of-type(1) {
      width: 100%;
      height: 310px;
      background-image: url("../assets/images/Home/company-left.jpg");
      background-size: 100% 100%;
      background-repeat: no-repeat;
      background-position: center;
    }
    > div:nth-of-type(2) {
      flex: 1;
      height: 324px;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
      line-height: 36px;
    }
  }
  .orange-color {
    color: $orange-color;
  }
  .common-box {
    width: 100vw;
    margin: 0 auto;
  }
  .header {
    text-align: center;
    font-size: 24px;
    color: #333333;
    font-weight: 600;
    padding:20px;
  }
  .product-box {
    text-align: center;
    background-color: white;
    .header {
      
    }
    ul {
      width: 100vw;
      display: inline-block;
     
    }
  }
  .company-box {
    .header {
     
    }
    section {
      text-align: left;
      padding:26px 0px;
      background-color: white;
      > div:nth-of-type(2) {
       margin:0px 13px;
      }
      .text-intro {
        margin-top: -11px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        div {
          text-indent: 2em;
        }
      }
    }
  }
  .rz-box {
    background-color: white;
    .rz-container {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      flex-wrap: wrap;
      > div {
        width: 49%;
        height: 268px;
        @include bg-common;
      }
      > div:nth-of-type(1) {
        background-image: url("../assets/images/Home/1-rz.png");
      }
      > div:nth-of-type(2) {
        background-image: url("../assets/images/Home/2-rz.png");
      }
      > div:nth-of-type(3) {
        background-image: url("../assets/images/Home/3-rz.png");
      }
      > div:nth-of-type(4) {
        background-image: url("../assets/images/Home/4-rz.png");
      }
      > div:nth-of-type(5) {
        background-image: url("../assets/images/Home/5-rz.png");
      }
    }
  }
  footer {
    height: 283px;
    background-color: #404040;
    .footer-container {
      color: #838383;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #838383;
      text-align: center;
      line-height: 61px;
    }
    .footer-box {
      background-color: #4c4c4c;
      height: 221px;
      .common-box{
       padding: 0px 10px;
    box-sizing: border-box;
    >div:nth-of-type(1){
      margin-right: 4px;
    }
      }
   
      .flex-row {
        justify-content: space-between;
        display: flex;
        flex-direction: row;
        padding-top: 14px;
        .title {
          font-size: 14px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #ffffff;
          line-height: 36px;
        }
        span:not(.title) {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #c5c5c5;
          line-height: 29px;
        }
        > div {
          display: flex;
          flex-direction: column;
        }
      }
      img {
          width: 100px;
          height: 100px;
          display: inline-block;
          max-width: unset;
      }
      .common-box {
        height: 100%;
      }
    }
  }
  .zz-box {
    background-color: white;
    .zz-container {
      padding-bottom: 64px;
      background: white;
      display: flex;
     flex-wrap: wrap;
      justify-content: center;
      > div {
        width: 49%;
        display: inline-block;
        height: 250px;
        @include bg-common;
      }
      > div:nth-of-type(1) {
        background-image: url("../assets/images/Home/1@2x.png");
      }
      > div:nth-of-type(2) {
        background-image: url("../assets/images/Home/2@2x.png");
      }
      > div:nth-of-type(3) {
        background-image: url("../assets/images/Home/3@2x.png");
      }
      > div:nth-of-type(4) {
        background-image: url("../assets/images/Home/4@2x.png");
      }
      > div:nth-of-type(5) {
        margin-right: 0px;
        background-image: url("../assets/images/Home/5@2x.png");
      }
      > div:nth-of-type(6) {
        background-image: url("../assets/images/Home/6@2x.png");
      }
      > div:nth-of-type(7) {
        background-image: url("../assets/images/Home/7@2x.png");
      }
      > div:nth-of-type(8) {
        background-image: url("../assets/images/Home/8@2x.png");
      }
      > div:nth-of-type(9) {
        background-image: url("../assets/images/Home/9@2x.png");
      }
      > div:last-child {
        width: 93%;
        margin-right: 0px;
      }
    }
  }
  .example-box {
    .header {
      background-color: #f6f6f6;
    }
    > div {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      > div {
        width: 100vw;
        height: 275px;
        background-color: white;
      }
    }
    .example-container {
      margin-bottom: 73px;
      div {
        display: flex;
        flex-direction: column;
        align-items: center;
        > span {
          font-size: 18px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: $orange-color;
          line-height: 25px;
          margin-top: 21px;
          margin-bottom: 14px;
        }
        section {
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #666666;
          line-height: 30px;
          padding: 0px 10px;
          text-indent: 2em;
          text-align: left;
        }
      }
      > div:nth-of-type(1) {
        background-image: url("../assets/images/Home/1.png");
        @include bg-common;
      }
      > div:nth-of-type(3) {
        background-image: url("../assets/images/Home/2.png");
        @include bg-common;
      }
      > div:nth-of-type(5) {
        background-image: url("../assets/images/Home/3.png");
        @include bg-common;
      }
    }
  }
  .word-container {
    display: flex;
    flex-direction: column;
    margin: auto;
    position: absolute;
    height: 100%;
    background-color: rgba(0,0,0,0.3);
    .w1{
     animation:w1a 1.5s 1.5s alternate forwards;
     font-size: 19px;
    }
    .w2{
        animation:w2a 1.5s 2s alternate forwards;
        font-size: 19px;
    }
    .w3{
        animation:w3a 1.5s 2.7s alternate forwards;
        font-size: 19px;
    }
    
    > span {
      display: block;
      position: relative;
      color: white;
      opacity: 0;
      font-size: 20px;
      position: relative;
      //  transform: translateX(0px);
    }
    > span:nth-of-type(1) {
      
      font-size: 35px;
    }
    > span:nth-of-type(2) {
     
      font-size: 20px;
      ;
    }
    > span:nth-of-type(3) {
    
      font-size: 24px;
      
    }
  }
  .banner {
    height: calc(100vh - 56px);
    width:100vw;
    background-image: url("../assets/images/Home/home-top.jpg");
    background-size: 150% 100%;
    background-repeat: no-repeat;
    background-position: center;
    display: flex;
    justify-content: center;
    position: relative;
  }
  .full-box {
    width: 100%;
  }
  .top {
     height: 56px;
    position: fixed;
    top: 0px;
    z-index: 99;
    left: 0px;
    right: 0px;
    background-color: white;
}
  .logo-img {
       width: 150px;
    height: 47px;
    margin-top: 5px;
    margin-left: 7px;
  }

  .max-box {
    width: 100vh;
    margin: auto;
    display: flex;
    background-color: transparent;
    .arrow-top {
      width: 56px;
      position: absolute;
      background-color: red;
      top: 0px;
      right: 0px;
      height: 2px;
      display: inline-block;
      transition: 0.5s;
    }
    .arrow-bottom {
      width: 56px;
      position: absolute;
      background-color: red;
      bottom: 0px;
      right: 0px;
      height: 2px;
      display: inline-block;
      transition: 0.5s;
    }
  }
  header {
    background: white;
    .max-box {
      display: flex;
      justify-content: space-between;
      ul {
        display: flex;
        width: 360px;
        position: relative;
        li {
          flex: 1;
          text-align: right;
          font-size: 14px;
          line-height: 72px;
          span {
            height: 72px;
            display: inline-block;
            cursor: pointer;
            top: 2px;
            width: 56px;
          }
        }
      }
    }
  }

  // > span:nth-of-type(1) {
  //     left: 147px;
  //     font-size: 24px;
  //   }
  //   > span:nth-of-type(2) {
  //     left: 203px;
  //     font-size: 48px;
  //     top: 130px;
  //   }
  //   > span:nth-of-type(3) {
  //     left: 895px;
  //     font-size: 24px;
  //     top: 160px;
  //   }



  @keyframes w1a {
    0%{
        opacity: 0;
        top:30%;
        left:30px;
    }
    100%{
        opacity: 1;
        top:30%;
       left:30px;
    }
  }
    @keyframes w2a {
    0%{
        opacity: 0;
        top:35%;
        left: 60%;
    }
    100%{
        opacity: 1;
        top:35%;
        left:13%;
    }
  }
    @keyframes w3a {
     0%{
       top:40%;
        left:17%;
        opacity: 0;
    }
    100%{
      top:40%;
       left:22%;
        opacity: 1;
    
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/componentsNew/HomeMobile.vue